<kendo-formfield>
    <kendo-label [text]="caption | translate"></kendo-label>
    <kendo-dropdownlist [ngClass]="{'fx-fill': settings.fxFill}" [formControl]="control" [valuePrimitive]="primitiveValue"
        [data]="valuesList$ | async" [textField]="textField" [valueField]="valueField" (valueChange)="onChange($event)">
    </kendo-dropdownlist>
</kendo-formfield>
